import { LocationType } from 'domain/entity/location';

export default class Profile {
    constructor(
        readonly locale: string,
        readonly dateFormat: string,
        readonly thousandsSeparator: string,
        readonly decimalSeparator: string,
        readonly locationId: string,
        readonly locationName: string,
        readonly currencySymbolInLastPosition: boolean,
        readonly brandingId: number,
        readonly locationType: LocationType,
        readonly selectedLocationTags: string[],
        readonly resolutions: string[],
        readonly deploymentId: number
    ) {}
}
